// extracted by mini-css-extract-plugin
export default {"page":"ContactsPage_page__6qY5K","page__header":"ContactsPage_page__header__zFs4O"};